import React from "react";

/*
========================================================
PLAN CARD
--------------------------------------------------------
Purpose:
- Displays one billing plan
- Used on the billing page
========================================================
*/

export default function PlanCard({ plan, onSelect, busy }) {
  const cardStyle = {
    background: "#13293d",
    borderRadius: 12,
    padding: 20,
    border: "1px solid rgba(255,255,255,0.08)",
  };

  const buttonStyle = {
    marginTop: 14,
    padding: "10px 16px",
    background: "#e0b84f",
    border: "none",
    borderRadius: 8,
    cursor: busy ? "not-allowed" : "pointer",
    color: "#0b1b2b",
    fontWeight: 700,
    opacity: busy ? 0.75 : 1,
  };

  return (
    <div style={cardStyle}>
      <h3 style={{ marginTop: 0, marginBottom: 8 }}>{plan.title}</h3>
      <div style={{ color: "#9fb0c3", marginBottom: 8 }}>{plan.priceLabel}</div>
      <div style={{ color: "#d7e7f5", lineHeight: 1.6 }}>{plan.description}</div>

      <button
        type="button"
        style={buttonStyle}
        disabled={busy}
        onClick={() => onSelect(plan.key)}
      >
        {busy ? "Working..." : `Choose ${plan.title}`}
      </button>
    </div>
  );
}
